/* eslint-disable import/prefer-default-export */
const loginFormText = {
  welcomeMsg: 'Welcome back!',
  enterLoginMsg: 'Enter your login information',
  usernameLabel: 'Username',
  passwordLabel: 'Password',
  forgotPasswordLink: 'Forgot Password?',
  loginButton: 'Login',
  copyright: `Copyright © ${new Date().getFullYear()} CellTrak Technologies, Inc. All rights reserved.`,
};

const loginAlerts = {
  errorAlert: 'errorAlert',
  successAlert: 'successAlert',
};

export { loginFormText, loginAlerts };
